import { Link } from "react-router-dom";
import { useSettings } from "@/contexts/SettingsContext";

// Normalize stored branding URLs so legacy/placeholder values still navigate correctly.
// - empty / anchor placeholders ("#privacy", "#contact", "#") fall back to the in-app route
// - absolute http(s) URLs render as external <a>
// - everything else renders as an internal <Link>
function resolveLinkTarget(stored, fallbackInternal) {
  if (!stored || typeof stored !== "string") return { kind: "internal", to: fallbackInternal };
  const trimmed = stored.trim();
  if (!trimmed || trimmed.startsWith("#")) return { kind: "internal", to: fallbackInternal };
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith("mailto:")) {
    return { kind: "external", to: trimmed };
  }
  // Treat relative path-like values ("/privacy", "privacy") as internal
  return { kind: "internal", to: trimmed.startsWith("/") ? trimmed : `/${trimmed}` };
}

function FooterLink({ stored, fallback, children, ...props }) {
  const target = resolveLinkTarget(stored, fallback);
  if (target.kind === "external") {
    return <a href={target.to} target="_blank" rel="noopener noreferrer" {...props}>{children}</a>;
  }
  return <Link to={target.to} {...props}>{children}</Link>;
}

export function AppFooter() {
  const { settings } = useSettings();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-card/50 py-6 px-6 text-sm text-muted-foreground" data-testid="app-footer">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
        <div data-testid="footer-copyright">© {year} {settings.app_name}. {settings.footer_text}</div>
        <nav className="flex items-center gap-5">
          <FooterLink stored={settings.privacy_url} fallback="/privacy" className="hover:text-primary transition-colors" data-testid="footer-privacy">Privacy Policy</FooterLink>
          <FooterLink stored={settings.contact_url} fallback="/contact" className="hover:text-primary transition-colors" data-testid="footer-contact">Contact</FooterLink>
        </nav>
      </div>
    </footer>
  );
}

export default AppFooter;
